export function ClientFingerPring() {
    /*
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    ctx.
     = 'top';
    ctx.font = '17px Arial';
    ctx.fillText('fingerprint', 10, 10);

     */
    //const canvasFingerprint = 0//canvas.toDataURL();

    const fingerprint = {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        language: navigator.language,
        screenResolution: `${window.screen.width}x${window.screen.height}`,
        colorDepth: window.screen.colorDepth,
        timezoneOffset: new Date().getTimezoneOffset(),
        //canvasFingerprint,
    };

    const fingerprintJSON = JSON.stringify(fingerprint);
    return fingerprintJSON
}

export function AccesTokenGUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
